import React from 'react';
import CSS from 'csstype';

import { Text } from './BodyText.styles';

import { BodyTextVariant, ColorsString } from './types';
import { FontWeight } from '../../../themeBase';

export type BodyTextProps = {
  /**
   * Text color
   */
  color?: ColorsString | string;
  /**
   * Predefined text variant
   */
  variant?: BodyTextVariant;
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Font weight
   */
  fontWeight?: FontWeight;
  /**
   * Font style
   */
  fontStyle?: CSS.Property.FontStyle;
  /**
   * Text align
   */
  textAlign?: CSS.Property.TextAlign;
  /**
   * Line height
   */
  lineHeight?: CSS.Property.LineHeight;
  /**
   * Allows to set text behaviour when text overflows its content box.
   */
  overflow?: 'truncate' | 'break-word';
  /**
   * White space
   */
  whiteSpace?: CSS.Property.WhiteSpace;
  /**
   * HTML tag to use for rendering
   */
  as?: React.ElementType;
};

const BodyText = ({
  variant = 'body1',
  fontWeight = 0,
  fontStyle = 'normal',
  color = 'black.main',
  textAlign = 'left',
  lineHeight,
  overflow,
  children,
  as = 'p',
  whiteSpace,
}: BodyTextProps) => (
  <Text
    whiteSpace={whiteSpace}
    as={as}
    color={color}
    fontFamily="secondary"
    fontStyle={fontStyle}
    fontWeight={fontWeight}
    textAlign={textAlign}
    variant={variant}
    lineHeight={lineHeight}
    overflow={overflow}
  >
    {children}
  </Text>
);

export default BodyText;
